import { createContext, useContext, useState } from 'react';
import PropTypes from 'prop-types';

const NavbarContext = createContext();

export const NavbarProvider = ({ children }) => {
  const [isExpanded, setIsExpanded] = useState(true);

  return (
    <NavbarContext.Provider value={{ isExpanded, setIsExpanded }}>
      {children}
    </NavbarContext.Provider>
  );
};
NavbarProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
export const useNavbar = () => useContext(NavbarContext);
